import React from "react";

const g = (v) => Number(v).toLocaleString("tr-TR");
const tl = (v) => `${Math.round(Number(v || 0)).toLocaleString("tr-TR")} ₺`;

export function LeaveEffectNote({ row, canSeeMoney }) {
  const parts = [];
  const money = (v) => (!canSeeMoney ? " kesilir" : Number(v) > 0 ? ` −${tl(v)}` : "");
  if (row.raporlu_gun > 0) parts.push({ t: `${g(row.raporlu_gun)} gün rapor${money(row.rapor_kesinti)}`, c: "text-rose-600" });
  if (row.ucretsiz_izin_gun > 0) parts.push({ t: `${g(row.ucretsiz_izin_gun)} gün ücretsiz izin${money(row.ucretsiz_izin_kesinti)}`, c: "text-rose-600" });
  if (row.ucretli_izin_gun > 0) parts.push({ t: `${g(row.ucretli_izin_gun)} gün ücretli/yıllık izin · kesinti yok`, c: "text-sky-700" });
  if (!parts.length) return null;
  return (
    <div className="text-[10px] mt-0.5 leading-tight" data-testid={`leave-effect-${row.personnel_id}`}>
      {parts.map((p, i) => <span key={p.t} className={p.c}>{i > 0 && <span className="text-slate-300"> · </span>}{p.t}</span>)}
    </div>
  );
}
